// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__P4WBI","right":"Footer_right__1oeaU","buttons":"Footer_buttons__1QsyU"};